export default "precision highp float;\nattribute vec2 a_position;\nvoid main() {\n    gl_Position = vec4(a_position, 0, 1);\n}"